import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy "Writing and editing" lesson: Snippets. Started from the lesson page
 * in a new tab; never auto-started. The officer opens a report and the
 * Snippets tab; later steps point at the Add Snippet button rather than
 * creating anything for them.
 */
const tour: TutorialDefinition = {
  id: "snippets",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Snippets",
  description: "Insert reusable text, and create your own with placeholders.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "snippets",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click any report.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: `${sel("editorSidebarTabs")} button[title="Snippets"]`,
      waitFor: `${sel("editorSidebarTabs")} button[title="Snippets"]`,
      waitTimeoutMs: 10000,
      title: "The Snippets tab",
      content: "Click Snippets in the right panel.",
      disableBeacon: true,
      placement: "left",
      advanceOn: { selector: `${sel("editorSidebarTabs")} button[title="Snippets"]`, event: "click" },
      hint: "Click the Snippets tab to continue",
      spotlightClicks: true,
    },
    {
      target: sel("snippetsPanel"),
      waitFor: sel("snippetsPanel"),
      title: "Insert a snippet",
      content:
        "Department Snippets come from your admin, and My Snippets are yours. Click one, then choose Add to cursor, Add to top of report, or Add to end of report.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("snippetAdd"),
      waitFor: sel("snippetAdd"),
      title: "Create your own",
      content:
        "Click Add Snippet, then fill in the Title and the Content. Write {{Name}} style placeholders for anything that changes per report.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("editorNarrative"),
      waitFor: sel("editorNarrative"),
      title: "Fill in placeholders",
      content: "After you insert a snippet with placeholders, click each highlighted placeholder in the narrative and type the real value.",
      disableBeacon: true,
      placement: "right",
    },
  ],
};

export default tour;
